import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface DefaultFooterProps {
  currentCount?: number;
  totalCount?: number;
  hasMore?: boolean;
  loading?: boolean;
}

const DefaultFooter = memo(({ currentCount, totalCount, hasMore, loading }: DefaultFooterProps) => {
  const { t } = useTranslation();
  return (
    <div className="text-center w-full text-xs italic px-2">
      {currentCount && totalCount
        ? t('common-items-count-range', { current: currentCount, total: totalCount })
        : totalCount
          ? t('common-items-count', { count: totalCount })
          : t('common-no-items')}
      {hasMore && !loading && <span className="ml-1 text-blue-500">{t('common-scroll-for-more')}</span>}
    </div>
  );
});

DefaultFooter.displayName = 'DefaultFooter';

export default DefaultFooter;
